import { useMutation } from '@apollo/client/react';
import { FormattedMessage } from 'react-intl';
import { ModalTypography } from 'components/styles_components/typography';
import { useError } from 'contexts/error';
import EditMutation from 'mutations/inspection/edit';
import Form from 'components/inspection/modal/edit/edit_form';

const deriveBucket = (inspection) => {
  if (inspection.canceled) return 'canceled';
  if (inspection.overdue) return 'overdue';
  if (inspection.incoming) return 'incoming';
  return 'pending';
};

const Edit = ({ handleClose, onSuccess, inspection }) => {
  const setError = useError();
  const [editMutation, { loading }] = useMutation(EditMutation, {
    onCompleted: onSuccess,
    onError: () => {
      setError('error.inspection.edit');
    },
  });

  return (
    <>
      <ModalTypography variant="h5" align="center">
        <FormattedMessage id="header.inspection.edit" />
      </ModalTypography>
      <Form
        initialValues={{
          id: inspection.id,
          name: inspection.name,
          placeId: inspection.place.id,
          inspectorId: inspection.inspector && inspection.inspector.id,
          inspectionSubjectId: inspection.inspectionSubject && inspection.inspectionSubject.id,
          bucket: deriveBucket(inspection),
          periodNumber: inspection.periodNumber,
          periodCycle: inspection.periodCycle,
          dueDate: inspection.dueDate && new Date(inspection.dueDate),
          notes: inspection.notes || undefined,
          inspectionFields: inspection.inspectionFields.map((field) => ({
            id: field.id,
            name: field.name,
            templateFieldId: field.templateFieldId,
          })),
        }}
        processing={loading}
        onSubmit={({ bucket: _bucket, ...values }) =>
          editMutation({ variables: values })
        }
        onCancel={handleClose}
      />
    </>
  );
};

export default Edit;
